<mat-list>
  @if (listItems?.length) {
  <mat-divider></mat-divider>
  } @for (listItem of listItems; track listItem) {
  <mat-list-item>
    <img matListItemAvatar [src]="listItem.logoSrc" alt="avatar" />
    <div matListItemTitle>
      {{ listItem.heading }}
      @if (listItem.verified || listItem.status === 'verified') {
      <mat-icon
        class="status-icon verified"
        svgIcon="verified"
        title="Skickad"
        role="img"
        aria-hidden="false"
        aria-label="Skickad"
      ></mat-icon>
      } @else if (listItem.status === 'retrying') {
      <mat-icon
        class="status-icon retrying"
        svgIcon="schedule"
        title="Skickas igen"
        role="img"
        aria-hidden="false"
        aria-label="Skickas igen"
      ></mat-icon>
      } @else if (listItem.status === 'failed') {
      <mat-icon
        class="status-icon failed"
        svgIcon="error_outline"
        title="Misslyckades"
        role="img"
        aria-hidden="false"
        aria-label="Misslyckades"
      ></mat-icon>
      }
    </div>
    <div matListItemLine>{{ listItem.h2 }}</div>
    <div matListItemLine>{{ listItem.h3 }}</div>
  </mat-list-item>
  <mat-divider></mat-divider>
  }
</mat-list>
